import React from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
    backgroundColor: '#fafafa',
  },
  container: {
    marginTop: '50px',
  },
  titleContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
    marginBottom: '20px',
    '& h5': {
      color: theme.palette.primary.main,
      position: 'relative',
    },
  },
  titleBackground: {
    position: 'absolute',
    top: '15px',
    left: '10px',
    width: '90%',
    backgroundColor: theme.palette.secondary.main,
    height: '18px',
    zIndex: -1,
  },
  icon: {
    marginRight: '20px',
    height: 'auto',
    minWidth: '40px',
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  feature: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '20px',
    padding: '20px',
    alignItems: 'center',
    '@media (max-width: 420px)': {
      minWidth: '100%',
      maxWidth: '100%',
    },
  },
  featureTitle: {
    marginBottom: '20px',
    fontSize: '16px',
    color: '#585858',
  },
  bullet: {
    margin: '20px 0',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
  },
  panel: {
    marginTop: '5px',
  },
  dataProvider: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& >p': {
      marginRight: '10px',
    },
  },
  subtitle: {
    fontSize: '18px',
    margin: '20px 0 10px 0',
  },
  title2: {
    fontSize: '20px',
    margin: '20px 0 10px 0',
  },
}))

function SeoText(): JSX.Element {
  const classes = useStyles({})

  return (
    <Box className={classes.root} id="read_more">
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div className={classes.titleBackground} />
          <Typography variant="h5">FAQ</Typography>
        </div>
        <Accordion square classes={{ root: classes.panel }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="subtitle2" className={classes.heading}>
              How do crypto cards work?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">
              A crypto debit card is exactly like your regular payment card, except that you have
              the option to load it with crypto instead of fiat. In other words, once loaded with
              crypto, the card can be used in the same manner as you would with your debit or credit
              card. For example, you can buy groceries, pay for petrol or book a holiday. Though you
              are spending your cryptos, the merchant is receiving payment in fiat (e.g USD or EUR).
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion square classes={{ root: classes.panel }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography variant="subtitle2" className={classes.heading}>
              What are the main advantages of crypto cards?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">
              Crypto cards are extremely convenient if you hold most of your funds in crypto but
              occasionally need to make spendings in the real world. Holding your fiat and crypto in
              the same wallet gives you a lot of flexibility. You can buy more crypto instantly when
              you feel like the timing is good or sell some of your holdings in a matter of minutes
              when you need some cash. Unlike with an exchange, where typically you have to wait for
              2-3 days for your funds to arrive back in your bank account.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion square classes={{ root: classes.panel }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography variant="subtitle2" className={classes.heading}>
              Which is the best crypto card?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">
              Crypto cards vary a lot by region because it is a very regulated space. Providers can
              not simply launch a card that works worldwide but launch one separately for every
              region and work with different partners for each. This being said for Europe we like
              Bitwala a lot and the best crypto card in the US is the Square Cash card in our
              opinion.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div className={classes.titleBackground} />
          <Typography variant="h5">How do crypto cards work?</Typography>
        </div>
        <div>
          <Typography variant="body1">
            Many people own cryptocurrencies and would like to pay for goods and services in the
            real-word with their cryptocurrency. The problem is that merchants simply don’t have the
            infrastructure in place to accept cryptocurrency payments. What most merchants do have
            however, are traditional payment terminals that accept Visa and Mastercard payments. A
            crypto debit card is exactly like a regular payment card, except that you have the
            option to load it with crypto instead of fiat. In most cases the provider offers an app
            that holds both crypto and fiat currencies like Euros or US Dollars. When users want to
            make a purchase in a store (or online ) they can convert their funds into fiat within
            the app and spend those funds instantly with their crypto debit card. In this process,
            merchants don’t need to make any changes to their payment terminals. Because funds are
            converted before they reach the merchant, merchants continue to receive funds in Euros
            or Dollars, nothing changes for them. That’s how crypto debit cards bridge the gap
            between the legacy fiat system and the future of cryptocurrencies.
          </Typography>
        </div>
      </div>
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div className={classes.titleBackground} />
          <Typography variant="h5">How to choose a crypto debit card </Typography>
        </div>
        <div className={classes.features}>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/percentage.svg"
              className={classes.icon}
              alt="percentage icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Conversion Costs
              </Typography>
              <Typography variant="body1">
                As a reference point, cryptocurrency exchanges, which are the cheapest option to
                convert funds take a 0.25% fee on average. In most cases, crypto card providers take
                a slightly higher fee than that in order to make a profit. It should not exceed 1%
                however otherwise you are overspending and should look for another crypto card.
              </Typography>
            </div>
          </div>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/exchange.svg"
              className={classes.icon}
              alt="exchange icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Conversion Speed
              </Typography>
              <Typography variant="body1">
                Conversion speed is the time it takes for your funds to be “spendable” after you
                traded crypto to fiat. In some cases you can spend your funds instantly, in others,
                you have to wait for up to 30 minutes for the trade to settle before you can spend,
                which can be inconvenient if you’re in a hurry. Some apps offer “auto-conversion”,
                which means you don’t have to do anything manual. The conversion happens in the
                background (instantly) as you put your payment card to use.
              </Typography>
            </div>
          </div>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/key.svg"
              className={classes.icon}
              alt="key icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Crypto Ownership
              </Typography>
              <Typography variant="body1">
                Most crypto card providers offer so-called custodial wallets, where you don’t have
                direct ownership over your funds. Instead, the provider stores your crypto for you
                (exactly like banks). Non-custodial wallets on the other hand, give you direct
                access to your funds and no one else but you with your private key can access them.
              </Typography>
            </div>
          </div>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/coins.svg"
              className={classes.icon}
              alt="coins icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Other Fees
              </Typography>
              <Typography variant="body1">
                It’s equally important to watch out for other fees that these providers charge.
                These can include monthly or yearly maintenance fees, a one-time card activation
                fee, ATM withdrawal fees or foreign currency exchange fees when you travel. We try
                to list these fees transparently so you can make the right decision.
              </Typography>
            </div>
          </div>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/currencies.svg"
              className={classes.icon}
              alt="currencies icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Currencies
              </Typography>
              <Typography variant="body1">
                Some wallets not only offer ONE fiat currency but a full fledged multi-currency
                account with the ability to convert one fiat currency into another (e.g Euros to
                Dollars). These are typically a great option for users who travel a lot.
              </Typography>
            </div>
          </div>
          <div className={classes.feature}>
            <img
              width={40}
              height={40}
              src="/svg/rewards.svg"
              className={classes.icon}
              alt="rewards icon"
            />
            <div>
              <Typography variant="subtitle1" className={classes.featureTitle}>
                Rewards
              </Typography>
              <Typography variant="body1">
                Look out for cards that offer cashbacks on every purchase made. These offers vary
                greatly. Some are free others require you to “stake” a certain crypto token to be
                eligible for the reward. Wirex and Crypto.com for example offer a low % reward for
                free but require you to “stake” their token to get the higher tiers.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default SeoText
